import { Backdrop } from '@mui/material';
import UPButton from 'components/button';
import { useTranslation } from 'react-i18next';
import {
  KIOSK__DISCARD_CONFIRM_BUTTON,
  KIOSK__DISCARD_CONFIRM_SUBTITLE,
  KIOSK__DISCARD_CONFIRM_TITLE,
  KIOSK__DISCARD_KEEP_BUTTON,
} from 'translations/constants';
import {
  KioskModalActions,
  KioskModalContainer,
  KioskModalStyled,
  KioskModalSubtitle,
  KioskModalTitle,
} from '../styles';

interface KioskDiscardConfirmModalProps {
  open: boolean;
  registrationId: number;
  discarding: boolean;
  onKeep: () => void;
  onDiscard: () => void;
}

const KioskDiscardConfirmModal = ({
  open,
  registrationId,
  discarding,
  onKeep,
  onDiscard,
}: KioskDiscardConfirmModalProps) => {
  const [t] = useTranslation();
  return (
    <Backdrop open={open} sx={{ zIndex: 4 }}>
      <KioskModalStyled open={open} onClose={onKeep}>
        <KioskModalContainer>
          <KioskModalTitle>{t(KIOSK__DISCARD_CONFIRM_TITLE)}</KioskModalTitle>
          <KioskModalSubtitle>{t(KIOSK__DISCARD_CONFIRM_SUBTITLE)}</KioskModalSubtitle>
          <KioskModalActions>
            <UPButton
              text={t(KIOSK__DISCARD_KEEP_BUTTON)}
              outlined
              onClick={onKeep}
              disabled={discarding}
              testId={`kiosk-discard-keep-${registrationId}`}
            />
            <UPButton
              text={t(KIOSK__DISCARD_CONFIRM_BUTTON)}
              onClick={onDiscard}
              disabled={discarding}
              testId={`kiosk-discard-confirm-${registrationId}`}
            />
          </KioskModalActions>
        </KioskModalContainer>
      </KioskModalStyled>
    </Backdrop>
  );
};

export default KioskDiscardConfirmModal;
